import React from 'react';
import { Link } from 'react-router-dom';
interface SectionHeadingProps {
  title: string;
  action?: {
    label: string;
    to: string;
  };
}
export function SectionHeading({
  title,
  action
}: SectionHeadingProps) {
  return <div className="mb-3 flex items-baseline justify-between gap-3" data-id="element-82" data-mp="3f2dqv26vxzyi">
      <h2 className="text-[15px] font-semibold tracking-tight text-white" data-id="element-83" data-mp="3jznc05n8rpgj">{title}</h2>
      {action && <Link to={action.to} className="rounded-full text-[12px] font-medium text-aura-bright transition-colors duration-200 ease-smooth hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-84" data-mp="bk3nfjximv7t">
          {action.label}
        </Link>}
    </div>;
}